import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import DOMPurify from 'dompurify';
import { showHideUserInfoModal } from 'actions/index';

class UserInfoModal extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        const { showHideUserInfoModal } = this.props;
        showHideUserInfoModal();
    }

    render() {
        const { modalTitle, buttonText, modalBody, actionComponent, className, userInfoModal } = this.props;
        return (
            <React.Fragment>
                {actionComponent ? actionComponent :
                    (
                        <a className="btn btn-light jr-btn-rounded" href="javascript:void(0)" onClick={this.toggle}>{buttonText}</a>
                    )
                }
                <div className="text-center">
                    <Modal isOpen={userInfoModal} toggle={this.toggle} className={className} style={{ maxHeight: 600, width: 400 }}>
                        <ModalHeader>{modalTitle}</ModalHeader>
                        <ModalBody>
                            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modalBody) }} />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={this.toggle}>Close</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </React.Fragment >
        );
    }
}


const mapStateToProps = ({ settings }) => {
    const { userInfoModal } = settings;
    return { userInfoModal };
};

export default connect(mapStateToProps, { showHideUserInfoModal })(UserInfoModal);


// WEBPACK FOOTER //
// ./components/userInfoModal/index.js